import Sessions from '../admin/Sessions';

export default function MySessions() {
  return <Sessions trainerOnly />;
}
